import tippyOriginal from 'tippy.js'

/* reexported with a TS type because original module has default export */
export const tippy = tippyOriginal as unknown as typeof tippyOriginal.default
